"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpPrintRubricPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var DpPrintRubricPage_styled_1 = require("./DpPrintRubricPage.styled");
var react_bootstrap_1 = require("react-bootstrap");
// import { useQuery } from '../../../../api';
var viewRubric_hook_1 = require("../ViewRubricHook/viewRubric.hook");
var DpWWAssessmentDecorator_1 = __importDefault(require("../../WWAssessmentDecorator/DpWWAssessmentDecorator"));
var Spinner_1 = require("../../Spinner/Spinner");
var router_1 = require("next/router");
var DpPrintRubricPage = function () {
    // ------------------ Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var router = (0, router_1.useRouter)();
    var _a = router.query, rubricReference = _a.rubricReference, type = _a.type, title = _a.title, curriculumId = _a.curriculumId;
    // ------------------ State
    var requestSignedCallback = function () { return window.print(); };
    var initialized = (0, viewRubric_hook_1.useRubricHook)({
        rubricReference: rubricReference,
        requestSignedCallback: requestSignedCallback,
        curriculumId: curriculumId,
    }).initialized;
    var getLernosityDataClasses = function () {
        return type === 'matrix' ? 'lernosity-matrix-data' : 'lernosity-rubric-data';
    };
    // ------------------ Render
    return ((0, jsx_runtime_1.jsx)(DpPrintRubricPage_styled_1.StyledPrintRubricPage, { children: initialized ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "title", children: (0, jsx_runtime_1.jsx)("h1", { id: "print-rubric-page-header", children: t("rubricAnalysis.".concat(type, ".modalTitle"), {
                            assessment: title,
                        }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "print-button", children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { onClick: function () { return window.print(); }, "aria-label": t("rubricAnalysis.printButton.ariaLabelText.".concat(type, ".ariaLabel")), "data-testid": "print-button", children: t("rubricAnalysis.printButton.title") }) }), (0, jsx_runtime_1.jsx)("div", { className: getLernosityDataClasses(), children: (0, jsx_runtime_1.jsx)(DpWWAssessmentDecorator_1.default, { isWitAndWisdom: true, children: (0, jsx_runtime_1.jsx)("div", { className: "learnosity-item", "data-reference": rubricReference }) }) })] })) : ((0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { className: "spinner" })) }));
};
exports.DpPrintRubricPage = DpPrintRubricPage;
exports.default = exports.DpPrintRubricPage;
